import React from "react";
import { Award, Users, HeartHandshake, Zap, Clock4, ShieldCheck } from "lucide-react";

const POINTS = [
  { icon: Award, title: "+ de 3 ans d'expérience", desc: "Indépendant à mon compte. Un savoir-faire affûté et une parfaite maîtrise du dépannage routier." },
  { icon: Users, title: "Respect du client", desc: "Je sais dialoguer, écouter et rassurer. Vous n'êtes pas un dossier — vous êtes une personne en panne." },
  { icon: HeartHandshake, title: "Respect du matériel", desc: "Votre véhicule est manipulé avec soin. Aucune dégradation, des sangles aux bons points d'ancrage." },
  { icon: Clock4, title: "Disponible 24h/24 · 7j/7", desc: "Jour, nuit, jours fériés. Une seule chose compte : vous remettre sur la route." },
  { icon: Zap, title: "Intervention 15 à 30 min", desc: "Selon le lieu, je suis sur place rapidement. Pas de temps perdu, pas de fausses promesses." },
  { icon: ShieldCheck, title: "Pro & assuré", desc: "Activité déclarée, intervention conforme. Vous êtes en sécurité, votre véhicule aussi." },
];

export const WhyUs = () => {
  return (
    <section id="pourquoi" className="relative py-24 sm:py-32 bg-[#0F0F0F] border-y border-white/5" data-testid="why-us-section">
      <div className="absolute inset-0 grid-noise opacity-30" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="text-[#FFD600] text-xs font-bold tracking-[0.3em] uppercase mb-3">
              — Pourquoi MK
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white uppercase tracking-tight">
              Sérieux,<br />
              <span className="text-[#FFD600]">rapide</span>,<br />
              respectueux.
            </h2>
            <p className="mt-6 text-neutral-400 text-lg leading-relaxed">
              MK Remorquage, c'est avant tout un homme de terrain : brave, fiable, et conscient que derrière chaque
              appel, il y a quelqu'un qui compte sur lui.
            </p>
            <div className="mt-8 inline-block hazard-stripes h-3 w-32 rounded-sm" />
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {POINTS.map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={i}
                  data-testid={`why-card-${i}`}
                  className="bg-[#171717] border border-[#262626] rounded-lg p-6 hover:border-[#FFD600]/40 transition-colors"
                >
                  <Icon className="w-7 h-7 text-[#FFD600] mb-4" strokeWidth={2} />
                  <h3 className="font-display text-lg text-white uppercase tracking-tight mb-2">{p.title}</h3>
                  <p className="text-sm text-neutral-400 leading-relaxed">{p.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
